import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_32: FaireProductEntity = {
  token: "legacy_prod_abbott-32",
  type: "product",
  name: 'Cat Face Measuring Tape 2.5" D',
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/5baf9ee54b033b8dc3b9cb01a1c24670815163e2fdec3c1f4793af3f71af394e.jpeg",
  priceDollars: 8,
  subcategory: "Scissors & Tools",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
